import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from "react-router-dom";
import { saveITMasterList, getITMasterMappingInfo, getITMasterList } from '../../services/it-depreciation.service';
import { getCompanyProfileList, getClasificationsList } from '../../services/user.service';
import * as CryptoJS from "crypto-js";

function MapITMasters() {
    // States
    const [companyId, setCompanyId] = useState('');
    const [classifications, setClasifications] = useState([]);
    const [itmasterlist, setITMasterList] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [fnclassification, setfnclassification] = useState('');
    const [itmasterlisting, setItmasterlisting] = useState('');

    // Error & Success States
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState('');
    const [ErrFnClassification, setErrFnClassification] = useState('');
    const [ErrItMasterList, setErrITmasterList] = useState('');

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const ITM_ID = query.get('itms_id');

    const resetForm = useCallback(() => {
        setCompanyId('');
        setfnclassification('');
        setItmasterlisting('');
        setErrMsg('');
        setSuccess('');
        setClasifications([]);
        setITMasterList([]);
    }, []);

    // 1. Fetch Classifications Based on Selected Company
    useEffect(() => {
        if (companyId) {
            try {
                const token = sessionStorage.getItem('LoggedInToken');
                const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': { 'company_id': companyId },
                    'authToken': token,
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

                getClasificationsList({ 'token': EncryptData }).then(res => {
                    if (res?.data?.data?.length) {
                        setClasifications(res.data.data);
                    } else {
                        setClasifications([]);
                    }
                }).catch(err => console.error("Error fetching classifications:", err));

                getITMasterList({ 'token': EncryptData }).then(res => {
                    if (res?.data?.data?.length) {
                        setITMasterList(res.data.data);
                    } else {
                        setITMasterList([]);
                    }
                }).catch(err => console.error("Error fetching it master list:", err));
            } catch (err) {
                console.error("Encryption error:", err);
            }
        } else {
            setClasifications([]);
            setITMasterList([]);
        }
    }, [companyId]);

    const getITMasterData = useCallback((itm_id) => {
        const token = sessionStorage.getItem('LoggedInToken');
        if (!token) return;

        try {
            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: { itm_id: itm_id },
                    authToken: token,
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            getITMasterMappingInfo({ token: EncryptData }).then((res) => {
                if (res?.data?.data?.length > 0) {
                    const info = res.data.data[0];
                    setCompanyId(info.company_id || '');
                    setTimeout(() => {
                        setfnclassification(info.fs_classification || '');
                        setItmasterlisting(info.it_master_id || '');
                    }, 500);
                }
            });
        } catch (e) {
            console.error("Fetch data error", e);
        }
    }, []);

    // Initial Load: Fetch Companies
    useEffect(() => {
        try {
            const token = sessionStorage.getItem('LoggedInToken');
            const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'company_id': sessionStorage.getItem('company_id') },
                'authToken': token,
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

            getCompanyProfileList({ 'token': EncryptData }).then(res => {
                if (res?.data?.data) setCompanies(res.data.data);
            });

            if (ITM_ID) {
                const formattedID = ITM_ID.replace(/ /g, '+');
                const decryptedBytes = CryptoJS.AES.decrypt(formattedID, process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decryptedStr = decryptedBytes.toString(CryptoJS.enc.Utf8);
                if (decryptedStr) {
                    const decrypt_data = JSON.parse(decryptedStr);
                    getITMasterData(decrypt_data.itm_id);
                }
            } else {
                resetForm();
            }
        } catch (err) {
            console.error("Init error:", err);
        }
    }, [ITM_ID, getITMasterData, resetForm]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let isValid = true;
        if (!companyId) { setErrCompanyId('Company is required. '); isValid = false; } else setErrCompanyId('');
        if (!fnclassification) { setErrFnClassification('Classification is required. '); isValid = false; } else setErrFnClassification('');
        if (!itmasterlisting) { setErrITmasterList('IT master is required. '); isValid = false; } else setErrITmasterList('');
        if (isValid) saveData();
    };

    const saveData = () => {
        try {
            let obj = { company_id: companyId, fs_classification: fnclassification, it_master_id: itmasterlisting, created_by: sessionStorage.getItem('LoggedInUserId') };
            if (ITM_ID) {
                const decryptedBytes = CryptoJS.AES.decrypt(ITM_ID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                obj.itms_id = decrypt_data.itm_id;
            }

            const encryptData = CryptoJS.AES.encrypt(JSON.stringify({
                param_data: obj,
                authToken: sessionStorage.getItem('LoggedInToken')
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

            saveITMasterList({ token: encryptData }).then(res => {
                if (res?.data?.success) {
                    setSuccess(res.data.message || "Saved successfully");
                    if (!ITM_ID) resetForm();
                } else {
                    setErrMsg(res.data.message || "Failed");
                }
            });
        } catch (err) { setErrMsg("Something went wrong"); }
    };

    return (
        <div className="container mt-4">
            <h5>{ITM_ID ? "Edit IT Master Mapping" : "Add IT Master Mapping"}</h5>
            {success && <div className="alert alert-success">{success}</div>}
            {errMsg && <div className="alert alert-danger">{errMsg}</div>}

            <form onSubmit={handleSubmit} className="mt-4">
                <div className="row mb-3 mt-3">
                    <div className="col-3"><label>Company <span className="text-danger">*</span></label></div>
                    <div className="col-3">
                        <select className="form-select" value={companyId} onChange={(e) => {
                            setCompanyId(e.target.value);
                            setfnclassification('');
                            setItmasterlisting('');
                        }}>
                            <option value="">Select Company</option>
                            {companies.map((opt) => (
                                <option key={opt.company_id} value={opt.company_id}>{opt.company_name}</option>
                            ))}
                        </select>
                        {ErrCompanyId && <small className="text-danger">{ErrCompanyId}</small>}
                    </div>
                </div>

                <div className="row mb-3 mt-3">
                    <div className="col-3"><label>Financial Classification <span className="text-danger">*</span></label></div>
                    <div className="col-3">
                        <select className="form-select" value={fnclassification}
                                onChange={(e) => setfnclassification(e.target.value)} disabled={!companyId}>
                            <option value="">----- Select Classification -----</option>
                            {classifications.map((opt) => (
                                <option key={opt.id} value={opt.id}>{opt.category_name}</option>
                            ))}
                        </select>
                        {ErrFnClassification && <small className="text-danger">{ErrFnClassification}</small>}
                        {!companyId && <small className="text-danger"> Please select a company first</small>}
                    </div>
                </div>

                <div className="row mb-3 mt-3">
                    <div className="col-3"><label>IT Master<span className="text-danger">*</span></label></div>
                    <div className="col-3">
                        <select className="form-select" value={itmasterlisting}
                                onChange={(e) => setItmasterlisting(e.target.value)} disabled={!companyId}>
                            <option value="">----- Select IT Master -----</option>
                            {itmasterlist.map((opt) => (
                                <option key={opt.id} value={opt.id}>{opt.block_name} ({opt.block_rate}%)</option>
                            ))}
                        </select>
                        {ErrItMasterList && <small className="text-danger">{ErrItMasterList}</small>}
                        {!companyId && <small className="text-danger"> Please select a company first</small>}
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-3"></div>
                    <div className="col-3">
                        <button type="submit" className="btn btn-primary btn-sm">
                            {ITM_ID ? "Update" : "Save"}
                        </button>
                    </div>

                </div>
            </form>
        </div>
    );
}

export default MapITMasters;